module.exports = __webpack_public_path__ + "media/brainstorm.45f58859.webm";